import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HelpComponent } from './help.component';
import { AuthGuard } from '../auth/auth.guard';
import { ThemeResolver } from '../../theme/theme.resolver';

const routes: Routes = [
  {
    path: 'help',
    component: HelpComponent,
    canActivate: [AuthGuard],
    resolve: { theme: ThemeResolver }
  }
];

export const router: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/modules/help/help.routes.ts